module.exports = __webpack_public_path__ + "static/img/ep3.0149ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/miembros/ep3.png
// module id = h14X
// module chunks = 0